import { object, boolean, string, array } from '@/_config/lib/yup';
import { ENUM_DENIED_REASONS } from '../footer-reasons/constants';

export const APPROVAL_MAT_FORM_SHECMA = object({
  showPersonalData: boolean(),
  hasApprovedPersonalData: boolean().when('showPersonalData', {
    is: true,
    then: boolean().required(),
  }),
  commentsPersonalData: string().optional(),

  showBankData: boolean(),
  hasApprovedBankAccount: boolean().when('showBankData', {
    is: true,
    then: boolean().required(),
  }),
  commentsBankAccount: string().optional(),

  showRg: boolean(),
  hasApprovedRg: boolean().when('showRg', {
    is: true,
    then: boolean().required(),
  }),
  commentsRg: string().optional(),

  showCnh: boolean(),
  hasApprovedCnh: boolean().when('showCnh', {
    is: true,
    then: boolean().required(),
  }),
  commentsCnh: string().optional(),

  showCrlv: boolean(),
  hasApprovedCrlv: boolean().when('showCrlv', {
    is: true,
    then: boolean().required(),
  }),
  commentsCrlv: string().optional(),

  showDeliverymanPicture: boolean(),
  hasApprovedDeliverymanPicture: boolean().when('showDeliverymanPicture', {
    is: true,
    then: boolean().required(),
  }),
  commentsDeliverymanPicture: string().optional(),

  showDeliverymanWithRgPicture: boolean(),
  hasApprovedSelfieWithRg: boolean().when('showDeliverymanWithRgPicture', {
    is: true,
    then: boolean().required(),
  }),
  commentsSelfieWithRg: string().optional(),

  valuesReasons: object({
    value: array().of(string().required()),
    comment: string().when(['value'], {
      is: (value: string[]) => value?.includes(ENUM_DENIED_REASONS.OTHERS),
      then: string().required(),
    }),
  }),
});
